export const Images = {
    logo: require('./logo.webp'),
    logoMin: require('./logo-min.webp'),
    logoTxt: require('./logo-txt.webp'),
    logoDrk: require('./logo-drk.webp'),
    blogo: require('./blogo.webp'),
    blogoDrk: require('./blogo-drk.webp'),
    nextIco: require('./next.webp'),
    nextIcoBlue: require('./next_blue.webp'),
    nextIcoWhite: require('./next_white.webp'),
    prevIco: require('./prev.webp'),
    prevIcoBlue: require('./prev_blue.webp'),
    prevIcoWhite: require('./prev_white.webp'),
    linchpin: require('./linchpin.webp'),
    conflictImg: require('./conflict.webp'),
    mediationImg: require('./mediation.webp'),
    trainingImg: require('./training.webp'),
    nkImg: require('./nyokabi_kamotho.webp'),
}